Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmitDeclarations = exports.register = void 0;
const vscode = require("vscode-languageserver-protocol");
const shared = require("@volar/shared");
function register(host, languageService, getTextDocument, ts) {
    return (uri, options) => {
        const document = getTextDocument(uri);
        if (!document)
            return [];
        const fileName = shared.uriToFileName(document.uri);
        const program = languageService.getProgram();
        const sourceFile = program === null || program === void 0 ? void 0 : program.getSourceFile(fileName);
        if (!program || !sourceFile)
            return [];
        const token = {
            isCancellationRequested() {
                var _a, _b;
                return (_b = (_a = host.getCancellationToken) === null || _a === void 0 ? void 0 : _a.call(host).isCancellationRequested()) !== null && _b !== void 0 ? _b : false;
            },
            throwIfCancellationRequested() { },
        };
        let errors = [];
        try {
            errors = [
                ...options.semantic ? program.getSemanticDiagnostics(sourceFile, token) : [],
                ...options.syntactic ? program.getSyntacticDiagnostics(sourceFile, token) : [],
                ...options.suggestion ? languageService.getSuggestionDiagnostics(fileName) : [],
            ];
            if (options.declaration && getEmitDeclarations(program.getCompilerOptions())) {
                errors = errors.concat(program.getDeclarationDiagnostics(sourceFile, token));
            }
        }
        catch (_a) { }
        return translateDiagnostics(document, errors);
        function translateDiagnostics(document, input) {
            return input.map(diag => translateDiagnostic(diag, document)).filter(shared.notEmpty);
        }
        function translateDiagnostic(diag, document) {
            if (diag.start === undefined)
                return;
            if (diag.length === undefined)
                return;
            const diagnostic = {
                range: {
                    start: document.positionAt(diag.start),
                    end: document.positionAt(diag.start + diag.length),
                },
                severity: translateErrorType(diag.category),
                source: 'ts',
                code: diag.code,
                message: getMessageText(diag),
            };
            if (diag.relatedInformation) {
                diagnostic.relatedInformation = diag.relatedInformation
                    .map(rErr => translateDiagnosticRelated(rErr))
                    .filter(shared.notEmpty);
            }
            if (diag.reportsUnnecessary) {
                if (diagnostic.tags === undefined)
                    diagnostic.tags = [];
                diagnostic.tags.push(vscode.DiagnosticTag.Unnecessary);
            }
            if (diag.reportsDeprecated) {
                if (diagnostic.tags === undefined)
                    diagnostic.tags = [];
                diagnostic.tags.push(vscode.DiagnosticTag.Deprecated);
            }
            return diagnostic;
        }
        function translateDiagnosticRelated(diag) {
            if (diag.start === undefined)
                return;
            if (diag.length === undefined)
                return;
            let document;
            if (diag.file) {
                document = getTextDocument(shared.fileNameToUri(diag.file.fileName));
            }
            if (!document)
                return;
            const diagnostic = {
                location: {
                    uri: document.uri,
                    range: {
                        start: document.positionAt(diag.start),
                        end: document.positionAt(diag.start + diag.length),
                    },
                },
                message: getMessageText(diag),
            };
            return diagnostic;
        }
        function translateErrorType(input) {
            switch (input) {
                case ts.DiagnosticCategory.Warning: return vscode.DiagnosticSeverity.Warning;
                case ts.DiagnosticCategory.Error: return vscode.DiagnosticSeverity.Error;
                case ts.DiagnosticCategory.Suggestion: return vscode.DiagnosticSeverity.Hint;
                case ts.DiagnosticCategory.Message: return vscode.DiagnosticSeverity.Information;
            }
            return vscode.DiagnosticSeverity.Error;
        }
    };
}
exports.register = register;
function getMessageText(diag, level = 0) {
    let messageText = '  '.repeat(level);
    if (typeof diag.messageText === 'string') {
        messageText += diag.messageText;
    }
    else {
        messageText += diag.messageText.messageText;
        if (diag.messageText.next) {
            for (const info of diag.messageText.next) {
                messageText += '\n' + getMessageText(info, level + 1);
            }
        }
    }
    return messageText;
}
function getEmitDeclarations(compilerOptions) {
    return !!(compilerOptions.declaration || compilerOptions.composite);
}
exports.getEmitDeclarations = getEmitDeclarations;
//# sourceMappingURL=diagnostics.js.map